import {createReducer} from 'actionware';
import customersApi from './services/customers';

// state tree
const initialState = {
  data: [],
};

// actions/action creators
export const fetch = (page, pageSize = 0, searchTerm, orderByEpicor) =>
  customersApi.fetch({
    page: page,
    pageSize: pageSize,
    searchTerm: searchTerm,
    sortByEpicor: orderByEpicor,
  });

// reducer
const reducer = createReducer(initialState).on(fetch, (state, response) => {
  return {
    ...state,
    data: response.result.data,
  };
});

export default reducer;
